<template>
  <div class="base-timer m-auto">
    <svg
      class="base-timer__svg"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="base-timer__circle">
        <circle
          class="base-timer__path-elapsed"
          cx="50"
          cy="50"
          r="45"
        ></circle>
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          :class="remainingPathColor"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <span class="base-timer__label">{{ formattedTimeLeft }}</span>

    <div class="m-auto pb-3 text-center">
      <b-button
        v-if="playTime"
        @click="playPause(false)"
        variant="warning"
        class="rounded-circle p-2 mr-4"
      >
        <i class="material-icons align-middle big-icon">pause</i>
      </b-button>
      <b-button
        v-else
        @click="playPause(true)"
        variant="info"
        class="rounded-circle p-2 mr-4"
      >
        <i class="material-icons align-middle big-icon">play_arrow</i>
      </b-button>
      <b-button
        @click="stop"
        variant="danger"
        class="rounded-circle p-2"
      >
        <i class="material-icons align-middle big-icon">stop</i>
      </b-button>
    </div>

    <b-row></b-row>
  </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

export default {
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      playTime: true,
      TIME_LIMIT:this.instance.hours*3600+this.instance.minutes*60
    };
  },
  props: {
    instance: {
      required: true,
      type: Object
    }
  },
  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      // //console.log(this.timeLeft)
      const timeLeft =Math.ceil(this.timeLeft)
       let hours = Math.floor(timeLeft/3600)
      
      let minutes = Math.floor((timeLeft % 3600)/60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

       if (hours < 10) {
        hours = `0${hours}`;
      }

      return `${hours}:${minutes}:${seconds}`;
    },

    timeLeft() {
      if(this.timePassed%60==0 && this.timePassed!=0 && this.timePassed!=this.TIME_LIMIT){
        // //console.log(this.instance.task.id)
        this.send_minute_spent(this.instance.task.id)
      }
      return this.TIME_LIMIT - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
      return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    }
  },

  watch: {
    timeLeft(newValue) {
      if (Math.ceil(newValue) === 0) {
        this.onTimesUp();
        this.stop();
      }
    }
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    ...mapActions('timer',['send_minute_spent']),
    onTimesUp() {
      clearInterval(this.timerInterval);

    },

    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 0.01), 10);
    },

    playPause(play){
      if(play){
        this.playTime=true
        this.startTimer()
      }
      else{
        this.playTime=false
        clearInterval(this.timerInterval);
      }
    },

    stop(){
      this.playTime=false
      clearInterval(this.timerInterval);
      this.instance.showMsgConfirm(this.timePassed)
    }

  }
};
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 320px;
  height: 320px;

  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 7px;
    stroke: grey;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      color: rgb(65, 184, 131);
    }

    &.orange {
      color: orange;
    }

    &.red {
      color: red;
    }
  }

  &__label {
    position: absolute;
    width: 320px;
    height: 320px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
  }
}
</style>
